import CryptoJSHmacSHA256 from 'crypto-js/hmac-sha256'
import CryproJSEncHex from 'crypto-js/enc-hex'

export const sign_key = '0bc339a7bc4f9f2db122bc39dd5889ce'

export function getCryptoJSResult(sign_key, params) {
  return CryproJSEncHex.stringify(CryptoJSHmacSHA256(params, sign_key))
}

export function encodePasswordBySha256(str) {
  return getCryptoJSResult(sign_key, str)
}

// 为空的值不需要传给后端，所以将对象中为空的key删除
export function deleteEmpty(options = {}) {
  for (let key in options) {
    if (
      options[key] === null ||
      options[key] === '' ||
      (options[key] + '').trim() === '' ||
      options[key] === undefined
    ) {
      delete options[key]
    }
  }
  return options
}
